/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
} from './Player';
import type { PlayerDetailsResponse } from './PlayerDetailsResponse';
import {
    PlayerDetailsResponseFromJSON,
    PlayerDetailsResponseFromJSONTyped,
    PlayerDetailsResponseToJSON,
} from './PlayerDetailsResponse';

/**
 * 
 * @export
 * @interface PlayerWithPAMDetails
 */
export interface PlayerWithPAMDetails {
    /**
     * 
     * @type {PlayerDetailsResponse}
     * @memberof PlayerWithPAMDetails
     */
    details: PlayerDetailsResponse;
    /**
     * 
     * @type {Player}
     * @memberof PlayerWithPAMDetails
     */
    player: Player;
}

/**
 * Check if a given object implements the PlayerWithPAMDetails interface.
 */
export function instanceOfPlayerWithPAMDetails(value: object): value is PlayerWithPAMDetails {
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('player' in value) || value['player'] === undefined) return false;
    return true;
}

export function PlayerWithPAMDetailsFromJSON(json: any): PlayerWithPAMDetails {
    return PlayerWithPAMDetailsFromJSONTyped(json, false);
}

export function PlayerWithPAMDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerWithPAMDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'details': PlayerDetailsResponseFromJSON(json['details']),
        'player': PlayerFromJSON(json['player']),
    };
}

export function PlayerWithPAMDetailsToJSON(value?: PlayerWithPAMDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'details': PlayerDetailsResponseToJSON(value['details']),
        'player': PlayerToJSON(value['player']),
    };
}

